import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/Common/ErrorBoundary";
import { Provider } from "react-redux";
import store from "./redux/store/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ConfigProvider } from "antd";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme/theme";
import { CssBaseline } from "@mui/material";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <Provider store={store}>
          <ConfigProvider
            theme={{
              token: {
                fontFamily: "Manrope",
                colorPrimary: "#00246a",
                colorPrimaryHover: "#00246a",
                colorPrimaryActive: "#00246a",
                colorPrimaryBg: "#00246a",
              },
            }}
          >
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <GoogleOAuthProvider
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
              >
                <App />
              </GoogleOAuthProvider>
            </ThemeProvider>
          </ConfigProvider>
        </Provider>
      </ErrorBoundary>
    </BrowserRouter>
  // </React.StrictMode>
);

reportWebVitals();
